<template>
  <div class="white-container" :key="$store.getters['resource/currentResource'].key">
    <b-form @submit.prevent="scheduleExportEdit" :params="this.$route.params">
      <b-row>
        <b-col  class="flex-column d-flex flex-row mb-2">
          <b-form-group label="Frequency" label-for="frequency">
            <b-form-select
                v-model="formData.scheduleFrequency"
                :options="frequencyOptions"
                id="frequency"
                required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="flex-column d-flex flex-row mb-2">
          <b-form-group label="Recipient email" label-for="recipientEmail">
            <b-form-input
                v-model="formData.recipientEmail"
                id="recipientEmail"
                required
                placeholder="Enter recipient email"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="auto" class="flex-column d-flex flex-row mb-2">
          <label class="switch switch-3d switch-success mr-2 mb-0">
            <b-form-checkbox
                type="checkbox"
                class="switch-input"
                id="status"
                v-model="formData.active"
            />
            <input type="checkbox" class="switch-input" :checked="formData.active"/>
            <span class="switch-slider"></span>
          </label>
        </b-col>
        <b-col class="d-flex align-items-center mb-2">
          <div
              class="status-text"
              @click="formData.active = !formData.active"
              style="cursor: pointer;"
          >
            {{ formData.active ? 'Active' : 'Inactive' }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <template>
            <b-button
                type="submit"
                class="mt-3"
            >Save
            </b-button>
          </template>
          <template>
            <b-button
                type="button"
                class="mt-3 ml-2"
                variant="outline-info"
                @click="redirect">
              {{ $t('button.cancel') }}
            </b-button>
          </template>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

export default {
  name: "EditSchedule",
  middleware: 'auth',
  props: {
    prefillParams: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        scheduleFrequency: '1 day',
        recipientEmail: null,
        active: false,
      },
      frequencyOptions: [
        {value: '1 day', text: '1 Day'},
        {value: '7 days', text: '7 Days'},
        {value: '1 month', text: '1 Month'},
        {value: '3 months', text: '3 Months'},
      ],
    };
  },
  computed: {
    id() {
      return this.$route.params.id || "";
    },
  },
  created() {
    if (!this.id) {
      this.$router.push({path: "/users"});
    } else {
      this.fetchScheduleData();
    }
  },
  methods: {
    async fetchScheduleData() {
      this.loading = true;
      this.loadingResources = true
      await this.getData(`/export-requests/scheduler/${this.id}`, null, true)
          .then(({data}) => {
            this.formData.scheduleFrequency = data.item.frequency || '';
            this.formData.recipientEmail = data.item.recipient_email || '';
            this.formData.active = data.item.active || false;
          })
      this.loading = false
      this.loadingResources = false
    },

    scheduleExportEdit() {
      const params = {
        frequency: this.formData.scheduleFrequency,
        recipient_email: this.formData.recipientEmail,
        active: this.formData.active,
      };
      this.putData(`/export-requests/scheduler/${this.id}`, params, '/users');
    },
    redirect() {
      if (this.backUrl) {
        this.$router.push({path: this.backUrl})
      } else {
        this.goBack()
      }
    },
  }
};
</script>